import { render, staticRenderFns } from "./LpuCard.vue?vue&type=template&id=4172d94e&scoped=true&"
import script from "./LpuCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuCard.vue?vue&type=style&index=0&id=4172d94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172d94e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4172d94e')) {
      api.createRecord('4172d94e', component.options)
    } else {
      api.reload('4172d94e', component.options)
    }
    module.hot.accept("./LpuCard.vue?vue&type=template&id=4172d94e&scoped=true&", function () {
      api.rerender('4172d94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/components/LpuCard.vue"
export default component.exports